import { useState } from "react";
import { PulseLoader } from "react-spinners";
import { useTranslation } from "react-i18next";
import { CreateCheckoutSession } from "./Requests";
import { formatMinor } from "../Components/Reusable/CurrencyFormatter/CurrencyFormatter";

const StepFive = (props) => {
  const { t } = useTranslation("makeBooking");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleCheckout = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    try {
      const res = await CreateCheckoutSession(
        props.barber.barberId,
        props.service.serviceId,
        props.timeId,
        props.service.duration,
        props.firstName,
        props.lastName,
        props.email,
        props.mobile,
        props.date,
        props.time
      );

      if (res.status === 200 && res.data?.url) {
        window.location.href = res.data.url;
        return;
      }

      setMessage(t("stepFive.messages.unableToStartCheckout"));
      props.bookingResult("failed");
    } catch (error) {
      setMessage(t("stepFive.messages.unableToStartCheckout"));
      props.bookingResult("failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form
      className="booking-portal-step-wrapper"
      onSubmit={handleCheckout}
      aria-label={t("stepFive.titles.payment")}
    >
      <div className="payment-container mt-3">
        <div className="card-element-wrapper">
          <div
            aria-label={t("stepFive.labels.serviceWithStaffAria", {
              service: props.service.name,
              staff: props.barber.name
            })}
          >
            {t("stepFive.labels.serviceWithStaff", {
              service: props.service.name,
              staff: props.barber.name
            })}
          </div>

          <div
            aria-label={t("stepFive.labels.dateTimeAria", {
              date: new Date(props.date).toDateString(),
              time: props.time
            })}
          >
            {t("stepFive.labels.dateTime", {
              date: new Date(props.date).toDateString(),
              time: props.time
            })}
          </div>

          <div
            aria-label={t("stepFive.labels.amountAria", {
              amount: formatMinor(props.service.onlinePaymentAmount, props.currency)
            })}
          >
            {formatMinor(props.service.onlinePaymentAmount, props.currency)}
          </div>
        </div>
      </div>

      <div className="payment-container">
        <div role="form" aria-label={t("stepFive.titles.payment")}>
          <div className="card-element-wrapper">
            <p className="payment-checkout-text">
              {t("stepFive.messages.redirectToStripe")}
            </p>
          </div>

          <button
            style={{ marginTop: "1rem" }}
            type="submit"
            className="submit-button"
            disabled={isLoading}
            aria-busy={isLoading ? "true" : "false"}
          >
            {isLoading ? (
              t("stepFive.actions.processing")
            ) : (
              t("stepFive.actions.payAmount", {
                amount: formatMinor(props.service.onlinePaymentAmount, props.currency)
              })
            )}
          </button>

          {isLoading && (
            <div style={{ marginTop: "1rem", display: "flex", justifyContent: "center" }}>
              <PulseLoader color={"#333"} size={10} aria-label="Loading" data-testid="loader" />
            </div>
          )}

          {message && <div role="alert" style={{ marginTop: "1rem" }}>{message}</div>}
        </div>
      </div>
    </form>
  );
};

export default StepFive;